// Создание ошибки
// errors.createError('Блин блинский...')
// errors.createError('Блин, засада!')

// Активация загрузки кнопки формы по сабмиту
// turnIntoLoader(e) запускается по сабмиту формы
// turnIntoButton(button) принимает аргументом либо саму кнопку,
// либо селектор кнопки, для которой надо прекратить лоадер

import axios from "axios";
import { turnIntoLoader, turnIntoButton } from "../../functions";
import * as errors from "../errors";
import { validate } from "./validation";
import store from "./store";
import { startFullPayment, startInstallmentPayment } from "./tcs-credit";
import { resultByPartsTotal, resultFullPriceTotal } from "./elements";

store.currentPrices = {
    full: parseInt(resultFullPriceTotal?.textContent?.replace(/\s+/g, "")),
    installment: parseInt(resultByPartsTotal?.textContent?.replace(/\s+/g, "")),
};

export async function formSubmit(e) {
    e.preventDefault();

    errors.removeError(".errors__item");

    turnIntoLoader(e.submitter);

    const formData = new FormData(e.target);

    let data = Object.fromEntries(formData);

    validate(data, e.submitter);

    const periods = [3, 4, 6, 10, 12, 18, 24, 36];

    const preparedData = {
        bank: data.bank,
        contact: data.telegram,
        good_id: data.good_id,
        first_name: data.name,
        email: data.email,
        promo: store.validPromocode || "",
        price_type: data["price-type"],
    };

    const paymentTypes = {
        tinkoff: 1,
        sber: 3,
        full: 6,
        split: 7,
    };

    if (preparedData.price_type === "by-parts") {
        preparedData.payment_type = paymentTypes[preparedData.bank];
        if (preparedData.bank == "sber") {
            preparedData.yookassa_type = "sber_loan";
        }
        preparedData.period = periods[data["period"]];
    } else if (preparedData.price_type === "full-price") {
        preparedData.full = data.full;
        preparedData.payment_type = paymentTypes[preparedData.full];
        preparedData.full_price = store.currentPrices.full;
    }

    const res = await axios.post("/payment", preparedData);

    preparedData.id = res.data.id;
    if (preparedData.price_type === "by-parts") {
        window.location = res.data.payment_url;
    } else if (preparedData.price_type === "full-price") {
        if (preparedData.payment_type == paymentTypes.split) {
            window.location = res.data.payment_url;
        } else {
            await startFullPayment(preparedData);
        }
    }

    turnIntoButton(e.submitter);
}
